module.exports = __webpack_public_path__ + "static/screen-web-finances-d7b68df9d57c06d991700257fa66af0d.png";